import { app, context, putContext, v } from "modular-openscriptjs";
import { getStoreSync } from "./helpers";
import { dom } from "./fotastart";

/**
 * Get Context
 */
putContext(["global", "user", "page"], "UrgentContext");
putContext("data", "DataContext");
putContext("payment");

/**
 * The global context.
 */
export const gc = context("global");

/**
 * The user context.
 */
export const uc = context("user");

/**
 * The data context.
 */
export const dc = context("data");

/**
 * The page data context.
 */
export const pc = context("page");

gc.states({
    auth: false,
    user: {},
    appLoaded: false,
    appConfigReloaded: false,
    appLoadedAt: null,
    appInForeground: true,
});

gc.qrScanner = null;

uc.states({
    permissions: new Set(),
    roles: new Set(),
    aiCredit: { balance: 0 },
    settings: {},
    errand: {},
    capa: { balance: 0 },
    orders: {},
    awards: [],
    addresses: [],
    cart: {},
    cartMap: {},
    paymentRequests: [],
    orderHistory: [],
    userBeingViewed: {},
    subscription: {},

    logisticsCompany: {},
    fleetType: "bicycle",
    pendingShoppingList: "",
    pendingShoppingImages: [],
    scheduleDate: "",
    scheduleTime: "",
});

pc.states({
    headerItems: [],
    sideItems: [],
    bottomItems: [],
    offCanvasItems: [],
    pageTitle: "",
    activePage: "",
    sideNavCollapsed: JSON.parse(getStoreSync("sideNavCollapse")) ?? false,
});

pc.sideNavCollapsed.listener(() => {
    let sideNav = dom.get("[ojs-hook='side-nav-container']");
    let mainContent = dom.get("[ojs-hook='main-content-container']");

    if (pc.sideNavCollapsed.value) {
        sideNav?.classList.remove("col-lg-3", "col-md-4");
        sideNav?.classList.add("col-lg-1", "col-md-1");

        mainContent?.classList.remove("col-lg-9", "col-md-6");
        mainContent?.classList.add("col-lg-11", "col-md-11");
    } else {
        sideNav?.classList.remove("col-lg-1", "col-md-1");
        sideNav?.classList.add("col-lg-3", "col-md-4");

        mainContent?.classList.remove("col-lg-11", "col-md-11");
        mainContent?.classList.add("col-lg-9", "col-md-7");
    }
});

dc.states({
    defaultCategory: {},
    categories: [],
    companies: [],
    featuredBusinesses: [],
    frequentlyOrderedProducts: [],
    notificationsCount: { total: 0, unread: 0 },
    productConfigurationMap: {},
    cartLoaded: false,
    searchPlaceholder: "Search for anything...",
    queuedSearchPlaceholder: "Search for anything...",
    searchQuery: "",
    searchSuggestions: [],
});

dc.permWaitInterval = 4 * 60 * 60 * 1000;
dc.longitude = null;
dc.latitude = null;
dc.capaSymbol = "Ç";
dc.userCurrency = "KES";
dc.searchHandlingRoutes = [
    "app.search",
    "user.view-profile",
    "companies.list",
    "category.products",
    "category.all-products",
    "business.view-profile",
    "business.subcategory.products",
];
window.userCurrency = dc.userCurrency;
window.capaSymbol = dc.capaSymbol;

dc.GA_PID = import.meta.env.VITE_GA_PID;
dc.currentCategory = {};

app().value("dc", dc);
app().value("uc", uc);
app().value("pc", pc);
app().value("gc", gc);
